export const Profile = ({ darkMode, ref }) => {
  const profilepic = "assets/lightpict.png";
  return (
    <div className="flex flex-col h-screen min-w-[320px] min-h-[850px] ">
      <div className="md:hidden mb-5 flex h-20 items-center md:mb-0 px-6 ">
        <p className="  text-xl  font-extrabold ">Y.Ichiba </p>
      </div>
      <div
        ref={ref}
        id="profile"
        className={` flex  h-screen flex-wrap md:flex-nowrap
          md:gap-10 lg:gap-16 xl:gap-24 
          justify-center  items-center 
          px-6 md:px-14 lg:px-20
          
          ${darkMode ? "text-white" : "text-black"}`}
      >
        <div className="flex flex-col justify-center h-fit md:w-1/2  max-w-[500px]  py-5">
          <h2 className=" pb-1 text-2xl">
            Hello,
            <br />
            My name is Youssef
          </h2>
          <p className="  text-lg md:text-base lg:text-lg text-gray-500 font-extralight pt-2 ">
            I'm a fresh graduate from{" "}
            <span className="font-bold"> 1337 School</span> with a strong
            passion for software engineering.
          </p>
          <p className="  text-lg md:text-base lg:text-lg text-gray-500 font-extralight pt-2 ">
            My areas of interest include
            <span className="font-bold"> problem-solving</span>,
            <span className="font-bold"> full-stack web development</span>, and{" "}
            <span className="font-bold"> AI</span>, with a focus on building
            scalable, high-performance applications.
          </p>
          <p className="  text-lg md:text-base lg:text-lg text-gray-500 font-extralight pt-2 ">
            I'm currently looking for an
            <span className="font-bold "> internship</span> where I can apply my
            skills, gain hands-on experience, and contribute to impactful
            projects.
          </p>
          <a
            href="./assets/resume.pdf"
            className={` pt-2 w-fit hover:underline
              ${darkMode ? " border-white" : " border-black"} `}
          >
            Get My Resume
          </a>
        </div>
        <div className=" relative min-w-[250px] max-w-[400px] lg:max-w-[400px] xl:max-w-[500px] md:max-w-[280px]px-3 ">
          <div
            className={` hidden md:block absolute top-16 left-16 h-full  w-full   ${
              darkMode ? " bg-[#26292a] " : "bg-[#e8e6e6] "
            } `}
          ></div>
          <div className="w-full">
            <img
              className=" relative w-full "
              src={profilepic}
              alt="my-picture"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

//  <div
//    onClick={() => setPopup(true)}
//    className="md:hidden  flex flex-col  items-end space-y-2 "
//  >
//    <div
//      className={`h-[1.5px] w-4 ${!darkMode ? "bg-[#181a1b] " : "bg-white"}`}
//    ></div>
//    <div
//      className={`h-[1.5px] w-7 ${!darkMode ? "bg-[#181a1b] " : "bg-white"}`}
//    ></div>
//  </div>;
//  {
//    popup && (
//      <div
//        className={`fixed top-0 left-0 w-full h-full ${
//          darkMode ? "bg-[#181a1b] text-white " : "bg-white text-black"
//        }`}
//      >
//        <div
//          onClick={() => setPopup(false)}
//          className="md:hidden  fixed top-10 right-10 flex flex-col  items-end space-y-2 "
//        >
//          <div
//            className={`h-[1.5px] w-4  ${
//              !darkMode ? "bg-[#181a1b] " : "bg-white"
//            }`}
//          ></div>
//          <div
//            className={`h-[1.5px] w-7 ${
//              !darkMode ? "bg-[#181a1b] " : "bg-white"
//            }`}
//          ></div>
//        </div>
//        <div
//          className={`h-full font-serif flex flex-col  text-gray-600 text-xl  justify-center items-center  gap-10 `}
//        >
//          <a
//            href="#Profile"
//            onClick={() => {
//              setPopup(false);
//              setManualScroll(true);
//              setActive("profile");
//            }}
//            className={`${
//              active === "profile" &&
//              `border-b-2 border-red-400 pb-1   ${
//                darkMode ? "text-white" : "text-black"
//              }`
//            } `}
//          >
//            Profile
//          </a>
//          <a
//            href="#Projects"
//            onClick={() => {
//              setPopup(false);
//              setManualScroll(true);
//              setActive("project");
//            }}
//            className={`${
//              active === "project" &&
//              `border-b-2 border-red-400 pb-1   ${
//                darkMode ? "text-white" : "text-black"
//              }`
//            } `}
//          >
//            Projects
//          </a>
//          <a
//            href="#Contact"
//            onClick={() => {
//              setPopup(false);
//              setManualScroll(true);
//              setActive("contact");
//            }}
//            className={`${
//              active === "contact" &&
//              `border-b-2 border-red-400 pb-1   ${
//                darkMode ? "text-white" : "text-black"
//              }`
//            } `}
//          >
//            Contact
//          </a>
//          <DarkModeToggle darkMode={darkMode} setDarkMode={setDarkMode} />
//        </div>
//      </div>
//    );
//  }
